import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable } from '@angular/material/table';
import { ChecklistInputItem } from '@gsm/entities';

@Component({
  selector: 'gsm-checklist',
  templateUrl: './checklist-item-list.component.html',
  styleUrls: ['./checklist-item-list.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatIconButton,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow
  ]
})
export class ChecklistItemListComponent {
  displayedColumns: string[] = [
    'checklistItem',
    'checklistStatus',
    'checklistCheck',
    'checklistEdit'
  ];
  editDisabled: boolean;

  @Input() checklistItemList: ChecklistInputItem[];

  @Input() set disableEdit(value: boolean) {
    this.editDisabled = value;
  }

  @Output() selectChecklistItem = new EventEmitter<ChecklistInputItem>();

  selectItem(cli: ChecklistInputItem) {
    this.selectChecklistItem.emit(cli);
  }

  getChecklistStatusLabel(status): string {
    return ChecklistStatusLabel[status];
  }

  getChecklistCheckIcon(status): string {
    return ChecklistCheckIcon[status];
  }
}

enum ChecklistStatusLabel {
  O = 'Wird nachgebracht',
  E = 'Erledigt',
  R = 'Eingabe erforderlich',
  N = 'Nicht verfügbar',
}

enum ChecklistCheckIcon {
  O = 'panorama_fish_eye',
  E = 'check_circle_outline',
  R = 'panorama_fish_eye',
  N = 'highlight_off',
}
